import SlideShowTitle from './SlideShowTitle';

export default SlideShowTitle;
